import { Component, Input, Output, EventEmitter } from '@angular/core';
declare var bootstrap;
declare var $: any;

@Component({
  selector: 'app-fav-video-item',
  templateUrl: './fav-video-item.component.html',
  styleUrls: ['./fav-video-item.component.scss']
})
export class FavVideoItemComponent {
  @Input() video:any;
  @Input() modalid:any;
  @Input() videosList:any;
  @Output() newItemEvent = new EventEmitter<string>();;
  videoDetails:any;
  
  openDetails(id: Number,modalid:any){
    this.videoDetails = '';
    this.videoDetails = this.videosList.filter(function(video:any) {
      return video.id == id;
    })[0]; 
    
    this.newItemEvent.emit(this.videoDetails);
    
    if(this.videoDetails.allowed==0){
      setTimeout(()=>{
        if(document.getElementById('videos-locked-popup-modal')){
          var myModal = new bootstrap.Modal(document.getElementById('videos-locked-popup-modal'), {
            keyboard: true
          })
          myModal.show()
          //console.log('show-new-vids modal')
        }
      },300)
      return 
    }

    setTimeout(function(){
      $('#'+modalid).modal('show');
    }, 100);
  }
  
  getThumbUrl(url : string){
    return  "assets/images/"+url
  }
  
}
